module.exports = __webpack_public_path__ + "static/media/Upload.e0299ca2.svg";